export const AGE_BOUNDS_MIN = 13;
export const AGE_BOUNDS_MAX = 65;

export const GENDER_MALE = 'm';
export const GENDER_FEMALE = 'f';

export const METERS_IN_KM = 1000;
export const METERS_IN_MI = 1609.34;

export const UNIT_KM = 'km';
export const UNIT_MI = 'mi';

export const IDB_NAME = 'gotu:lab';

export const IDB_LOCALFORAGE = `${IDB_NAME}:localforage`;
export const IDB_LOCALFORAGE_TABLE_GENERAL = 'general'; // IDB table for generic key/value pairs

export const ONLINE_DRAFT_PREFIX = 'draft-';

export const STATUSES = {
  INI: 'INI', // Campaign has been created in the sales too, its sale is not confirmed yet
  BRI: 'BRI', // Campaign brief
  WRK: 'WRK', // Campaign is being validated. The posts are being created
  CRE: 'CRE', // Posts are ready. The client can give feedback on the posts
  REW: 'REW', // One or more posts have been rejected, rework in progress
  CAP: 'CAP', // Posts are ready to go live. Campaign is being validated to go live
  ONL: 'ONL', // Campaign is running on Facebook
  FIN: 'FIN', // Campaign is finished on Facebook
  CAN: 'CAN', // Campaign has been canceled
};

export const MODES = {
  oneoff: 'oneoff',
  subscription: 'subscription',
};

export const FLOWS = {
  DEFAULT: 'DEFAULT',
  ASAP: 'ASAP',
};

export const STEP_STATUS = {
  completed: 'completed',
  in_progress: 'in_progress',
  waiting: 'waiting',
};

export const CLAIM_STATUS = {
  UNKNOWN: 'unknown',
  CLAIMED: 'claimed',
  UNCLAIMED: 'unclaimed',
};

export const CAMPAIGN_TABS = {
  DETAILS: 'details',
};

export const FILTER_TYPES = {
  MULTISELECT: 'multiselect',
  DATE_FROM_TO: 'datefromto',
  TEXT_INPUT: 'textinput',
  AUTOCOMPLETE: 'autocomplete',
};

export const EVENT_TYPES = {
  HISTORY: 'CreativeHistory',
  COMMENT: 'Comment',
  PREVIEW: 'CreativePreview',
  CAMPAIGN_HISTORY: 'CampaignHistory',
  EMAIL_LOG: 'EmailLog',
  SMS_LOG: 'SmsLog',
};

export const EVENT_TYPES_HISTORY = {
  OPERATOR_CHANGE: 'OPERATOR_CHANGE',
  CAMPAIGN_CHANGE: 'CAMPAIGN_CHANGE',
  NEW_TARGETING_APPLIED: 'NEW_TARGETING_APPLIED',
  NEW_TARGETING_REQUESTED: 'NEW_TARGETING_REQUESTED',
};

export const COMMENTABLE_TYPES = {
  CAMPAIGN: 'SeventySeven\\FbAdManager\\Models\\Campaign',
  CREATIVE: 'SeventySeven\\FbAdManager\\Models\\Creative',
};

export const CREATIVE_STATUSES = {
  ONBOARDING: 'ONBOARDING',
  BRIEF: 'BRIEF', // Initial status of creative
  WIP: 'WIP', // Work in progress (operators started to work on posts)
  HOLD: 'HOLD', // Creative is put on hold
  READY: 'READY', // Creative is ready, waiting for client aprovement
  APPROVED: 'APPROVED', // Creative is approved
};

export const CAMPAIGN_TYPES = {
  IMAGE: 'image',
  CAROUSEL: 'carousel',
  SLIDESHOW: 'slideshow',
  VIDEO: 'video',
  EXTERNAL: 'external',
};

export const GOAL_TYPES = {
  NO_BUTTON: 'NO_BUTTON',
  APPLY_NOW: 'APPLY_NOW',
  BOOK_TRAVEL: 'BOOK_TRAVEL',
  CONTACT_US: 'CONTACT_US',
  LEARN_MORE: 'LEARN_MORE',
  SHOP_NOW: 'SHOP_NOW',
  SIGN_UP: 'SIGN_UP',
  WATCH_MORE: 'WATCH_MORE',
  DOWNLOAD: 'DOWNLOAD',
  MESSAGE_PAGE: 'MESSAGE_PAGE',
  GET_SHOWTIMES: 'GET_SHOWTIMES',
  LISTEN_NOW: 'LISTEN_NOW',
  SEE_MENU: 'SEE_MENU',
  REQUEST_TIME: 'REQUEST_TIME',
  GET_QUOTE: 'GET_QUOTE',
  SUBSCRIBE: 'SUBSCRIBE',
  GET_OFFER: 'GET_OFFER',
};

export const LOGIN_TYPES = {
  EMAIL: 'email',
  SSO: 'sso',
};

export const GOAL_REACH_FREQUENCY = 'reach_frequency';
export const GOAL_POST_ENGAGEMENT = 'post_engagement';
export const GOAL_REACH_AND_CLICK = 'reach_and_click';
export const GOAL_LEAD_GENERATION = 'lead_generation';
export const GOAL_LOCAL_OFFERS = 'local_offers';

export const ENV_IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const ENV_IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const ENV_IS_TESTING = process.env.NODE_ENV === 'testing';

export const LOCALE_DEFAULT = 'en';
export const LOCALE_DEVELOPMENT = 'dev';
export const LOCALE_FALLBACK = ENV_IS_DEVELOPMENT ? undefined : LOCALE_DEFAULT;

export const GOOGLE_MAPS_KEY = process.env.GOOGLE_MAPS_KEY;

export const DOCUMENT_TITLE = process.env.DOCUMENT_TITLE || 'GotU Lab';

export const PHP_CONFIG_PATH = '/php/config.php';

export const DEFAULT_FAVICON_URL = '/static/favicon.ico';

export const DEFAULT_COLORS = {
  primary: '#2e4057',
  secondary: '#47b383',
  tertiary: '#398f68',
  'theme-white': '#ffffff',
  'theme-very-light-grey': '#fafafa',
  'theme-light-grey': '#eeeeef',
  'theme-grey': '#dddddd',
  'theme-dark-grey': '#b5b5b5',
  'theme-very-dark-grey': '#212121',
  'theme-black': '#000000',
  'theme-error': '#d9534f',
  'theme-success': '#8cbc41',
  'theme-warning': '#fac330',
  'theme-info': '#17a2b8',
  'facebook-blue': '#4267b2',
};

export const CAMPAIGN_SUBSCRIPTION = {
  periodCount: '999',
  periodLength: '1',
  periodType: 'months',
  periodTypes: ['month', 'months', 'day', 'days'],
};

export const USER_GROUPS = {
  CLIENT: 'Client',
  SALES_REP: 'Sales Representative',
  OPERATOR: 'Operator',
  SUPER_USER: 'Super User',
  READ_ONLY: 'Read Only',
  CAMPAIGN_MANAGER: 'Campaign Manager',
};

export const NOTIFICATION_EVENTS = {
  CREATIVITY_AD_PROPOSAL_REVIEW: 'CREATIVITY_AD_PROPOSAL_REVIEW',
  CREATIVITY_WE_ARE_SETTING_YOU_LIVE: 'CREATIVITY_WE_ARE_SETTING_YOU_LIVE',
  CAMPAIGN_STATUS_ENTER_FIN: 'CAMPAIGN_STATUS_ENTER:FIN',
  ONBOARDING_WARNING: 'ONBOARDING_WARNING',
  ONBOARDING_SUCCESSFUL: 'ONBOARDING_SUCCESSFUL',
  ONBOARDING_UNSUCCESSFUL: 'ONBOARDING_UNSUCCESSFUL',
  CAMPAIGN_CUSTOMER_ACCESS_DETAILS: 'CAMPAIGN_CUSTOMER_ACCESS_DETAILS',
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/utils/constants.js